// src/api.js
import axios from 'axios';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.withCredentials = true

// Global flag to prevent multiple simultaneous clear operations
let isClearingStorage = false;

// Function to clear all browser storage and reload
function clearStorageAndReload() {
  if (isClearingStorage) {
    return; // Already clearing, prevent duplicate calls
  }
  
  isClearingStorage = true;
  
  try {
    console.log('401 Unauthorized detected. Clearing all storage...');
    
    // Clear localStorage completely
    localStorage.clear();
    
    // Clear sessionStorage completely
    sessionStorage.clear();
    
    // Clear cookies (if any authentication cookies exist)
    if (document.cookie) {
      document.cookie.split(";").forEach(cookie => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        // Clear cookie for current path and root path
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
      });
    }
    
    console.log('Storage cleared. Reloading page...');
    
    // Force reload the page immediately (no timeout for faster response)
    window.location.replace('/');
    
  } catch (clearError) {
    console.error('Error clearing storage:', clearError);
    // Even if clearing fails, try to reload
    window.location.replace('/');
  }
}

// Store original axios.create to intercept instance creation
// This ensures ALL axios instances get the 401 handler
const originalAxiosCreate = axios.create;
axios.create = function(config) {
  const instance = originalAxiosCreate.call(this, config);
  
  // Add 401 interceptor to every new axios instance
  instance.interceptors.response.use(
    response => {
      isClearingStorage = false;
      return response;
    },
    error => {
      if (error.response && error.response.status === 401) {
        const isLoginRequest = error.config?.url?.includes('/login') || 
                              error.config?.url?.includes('/register');
        
        if (!isLoginRequest) {
          clearStorageAndReload();
        }
      }
      return Promise.reject(error);
    }
  );
  
  return instance;
};

// Add global response interceptor to handle 401 unauthorized errors
// This will work for the default axios instance
axios.interceptors.response.use(
  response => {
    // Reset flag on successful response
    isClearingStorage = false;
    return response;
  },
  error => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/login') || 
                            error.config?.url?.includes('/register');
      
      // Only clear if it's NOT a login/register request
      // (login requests can return 401 for wrong credentials, which is normal)
      if (!isLoginRequest) {
        // Clear storage immediately for any 401 error (except login/register)
        clearStorageAndReload();
      }
    }
    
    return Promise.reject(error);
  }
);

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api',
});

// Add a request interceptor to include the token in headers if available
api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export const login = async (login, password) => {
  alert("ok")
  const response = await api.post('/login', { login, password });
  return response.data;
};
export const register = async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  };

export const logout = async () => {
  const response = await api.post('/logout');
  return response.data;
};






export default api;
